import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png";
import useUser from "../hooks/useUser";
import { auth } from "../config/firebase.config";
import { HiLogout } from "react-icons/hi";
import "../assets/css/style.css";
import { adminIds } from "../utils/helper";


function Header() {
  const { data: user } = useUser();
  const [menuOpen, setMenuOpen] = useState(false);
  const [resumeOpen, setResumeOpen] = useState(false);
  const [coverOpen, setCoverOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    setResumeOpen(false);
    setCoverOpen(false);
  };

  const signOutUser = async () => {
    await auth.signOut();
    window.location.reload();
  };

  return (
    <nav className="nav-container">
      <div className="nav-content">
        
        {/* Logo */}
        <Link to="/" className="nav-logo">
          <img src={logo} alt="Logo" />
        </Link>

        {/* Hamburger */}
        <div className="hamburger" onClick={toggleMenu}>
          <span className={menuOpen ? "bar open" : "bar"}></span>
          <span className={menuOpen ? "bar open" : "bar"}></span>
          <span className={menuOpen ? "bar open" : "bar"}></span>
        </div>

        {/* Menu */}
        <ul className={menuOpen ? "nav-menu active" : "nav-menu"}>

          <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link></li>

          {/* Resume Dropdown */}
          <li className="dropdown">
            <span
              onClick={() => setResumeOpen(!resumeOpen)}
              className="dropdown-toggle"
            >
              Resume
            </span>
            <ul className={resumeOpen ? "dropdown-menu show" : "dropdown-menu"}>
              <li><Link to="/homescreen" onClick={toggleMenu}>Examples</Link></li>
              <li><Link to="/homescreen" onClick={toggleMenu}>Templates</Link></li>
            </ul>
          </li>

          {/* Cover Letter Dropdown */}
          <li className="dropdown">
            <span
              onClick={() => setCoverOpen(!coverOpen)}
              className="dropdown-toggle"
            >
              Cover Letter
            </span>
            <ul className={coverOpen ? "dropdown-menu show" : "dropdown-menu"}>
              <li><Link to="/" onClick={toggleMenu}>Examples</Link></li>
              <li><Link to="/" onClick={toggleMenu}>Templates</Link></li>
            </ul>
          </li>

          <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>

          {user ? (
  <li className="dropdown">
    <div
      className="avatar"
      onClick={() => setMenuOpen(prev => !prev)}
    >
      {user.photoURL ? (
        <img src={user.photoURL} alt="avatar"/>
      ) : (
        <span>{user.email[0].toUpperCase()}</span>
      )}
    </div>

    <ul className={menuOpen ? "dropdown-menu show" : "dropdown-menu"}>
      <li><Link to={`/homescreen/profile/${user.uid}`} onClick={toggleMenu}>My Account</Link></li>

      {/* If Admin */}
      { adminIds.includes(user.uid) && (
        <li><Link to="/homescreen/template/create" onClick={toggleMenu}>Add New Template</Link></li>
      ) }

      <li>
        <button onClick={signOutUser} style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
          <HiLogout/> Sign Out
        </button>
      </li>
    </ul>
  </li>
) : (
  <li className="auth-btn">
    <Link to="/auth">Login</Link>
  </li>
)}

        </ul>

      </div>
    </nav>
  );
}

export default Header;
